'use client';

import { Bot, CalendarCheck, Heart, LucideIcon, Upload } from 'lucide-react';
import { useAuthStore } from '@/stores/useAuthStore';
import IconAdaptive from '@/components/IconAdaptive';

export default function DashboardActivityDataUnit() {
    const userScore = useAuthStore((s) => s.userScore);

    const items: { icon: LucideIcon; label: string; value?: number }[] = [
        { icon: Bot, label: '所属しているラボ数', value: userScore?.ownedLabCount ?? 0 },
        { icon: Upload, label: 'マイラボがアップロードしたギアの数', value: userScore?.gearPostCount ?? 0 },
        { icon: Heart, label: 'ギアがいいねされた数', value: userScore?.gearLikeCount ?? 0 },
        { icon: CalendarCheck, label: 'フェスタチェックイン回数', value: userScore?.festaEntryCheckinCount ?? 0 },
    ];

    return (
        <div className="flex flex-col gap-y-2 w-full">
            {items.map(({ icon: Icon, label, value }) => (
                <div key={label} className="flex items-center gap-x-2 rounded-xl bg-color-white-base px-3 py-2">
                    <div className="flex items-center justify-center flex-none">
                        <IconAdaptive Icon={Icon} baseSize={18} strokeWidth={1.8} className="text-color-co-gray-dark" />
                    </div>
                    <div className="font-corp font-bold text-[11px] md:text-xs text-color-base leading-tight">
                        {label}
                    </div>
                    <div className="font-cantarell font-bold text-lg text-color-c-orange leading-none ml-auto pl-2">
                        {value}
                    </div>
                </div>
            ))}
        </div>
    );
}
